import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Switcher from '../../../ui/Switcher';
import sqftShape from '../../../canvas/core/shapes/sqftShape';
import { updateTallCabinetIn3D } from '../../../ar3d/threeD/glbViewer/scene/modelsLoader/cabinetInterior/tallCabinetUpdate3D';

const DoorExtensionSwitcher = ({ shape, onChange }) => {
  const [isEnabled, setIsEnabled] = useState(() => shape.shapeCabinet.getDoorExtensionEnabled());

  useEffect(() => {
    setIsEnabled(shape.shapeCabinet.getDoorExtensionEnabled());
  }, [shape]);

  const handleChange = (nextIsEnabled) => {
    shape.shapeCabinet.setDoorExtensionEnabled(nextIsEnabled);
    updateTallCabinetIn3D(
      shape.id,
      shape.shapeCabinet.getCabinetInteriorLayout(),
      { updateGeometry: false }
    );
    setIsEnabled(nextIsEnabled);

    if (onChange) {
      onChange(nextIsEnabled);
    }
  };

  return (
    <div className="sr__section sr__door-extension">
      <div className="sr__section-title">
        <FormattedMessage id="sqft.cabinets.attributes.enableDoorExtension" defaultMessage="Enable Door Extension" />
        <span>
          <Switcher value={isEnabled} onChange={handleChange} />
        </span>
      </div>
    </div>
  );
};

DoorExtensionSwitcher.propTypes = {
  shape: PropTypes.instanceOf(sqftShape).isRequired,
  onChange: PropTypes.func,
};

DoorExtensionSwitcher.defaultProps = {
  onChange: null,
};

export default DoorExtensionSwitcher;
